import { axiosApi } from "shared/api/axios";

export const getOrderClients = async (currentPage: number, id?: string): Promise<any> => {
    try {
        const url = `${process.env.API_BACKEND}/v1/bookings/order/?counterparty_filter=${id}&page=${currentPage}&size=10`
        
        const response = await axiosApi.get<any>(url);
        return response.data;
    } catch(err) {
        console.error(err);
        throw new Error("Ошибка получения заказа");
    }
}